import { useEffect, useRef } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useChat } from '../../providers/chat/context'

export default function ChatTabs() {
  const { tabs, activeId, openThread, closeTab } = useChat()
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    scrollRef.current
      ?.querySelector('[data-active]')
      ?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' })
  }, [activeId, tabs.length])

  return (
    // pb-px keeps the active tab's 1px overlap from being clipped by the scroller
    <div
      ref={scrollRef}
      className="overflow-x-auto pb-px [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      <div className="flex w-max items-end gap-px">
        {tabs.map((thread) => {
          const active = thread.id === activeId
          return (
            <div
              key={thread.id}
              data-active={active || undefined}
              className={`group flex h-9 max-w-36 shrink-0 items-center rounded-t-lg border pr-2 pl-3.5 text-xs transition-colors sm:max-w-52 ${
                active
                  ? '-mb-px z-10 border-stone-200 border-b-0 bg-stone-100 font-medium text-stone-900'
                  : 'border-transparent text-stone-500 hover:bg-stone-200 hover:text-stone-900'
              }`}
            >
              <button
                type="button"
                title={thread.title || 'New conversation'}
                onClick={() => void openThread(thread.id)}
                className="min-w-0 flex-1 truncate text-left"
              >
                {thread.title || 'New conversation'}
              </button>
              <button
                type="button"
                aria-label="Close tab"
                onClick={() => closeTab(thread.id)}
                className="ml-1.5 shrink-0 rounded-full p-0.5 opacity-0 transition group-hover:opacity-100 focus-visible:opacity-100 hover:bg-stone-300 pointer-coarse:opacity-100"
              >
                <XMarkIcon className="size-3.5 text-stone-400" />
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}
